import { checkAuthorizationView } from '../services/authorization-service';
import SubscriptorList from '../pages/subscriptor/list';
import AddSubscriptorForm from '../pages/subscriptor/add';
import ResultView from '../pages/subscriptor/result';

export const SUBSCRIPTOR_LIST_PATH = '/subscriptor/list';
export const SUBSCRIPTOR_ADD_PATH = '/subscriptor/add';
export const SUBSCRIPTOR_RESULT_PATH = '/subscriptor/result/:id';

export const SubscriptorFormRouters = [
  {
    path: SUBSCRIPTOR_LIST_PATH,
    exact: true,
    component: checkAuthorizationView(SubscriptorList, ['SUBSCRIPTOR_LIST'])
  },
  {
    path: SUBSCRIPTOR_ADD_PATH,
    exact: true,
    component: checkAuthorizationView(AddSubscriptorForm, ['ADD_SUBSCRIPTOR'])
  },
  {
    path: SUBSCRIPTOR_RESULT_PATH,
    exact: true,
    component: checkAuthorizationView(ResultView, ['SUBSCRIPTOR_DETAIL'])
  }
];
